import { SignalType } from '@firmable/contracts/src/Api/Signals';

export const SIGNAL_TYPE_TO_NOTIFICATION_BODY_SUFFIX: Record<SignalType, string> = {
  // Company signals
  'company-awards-recognitions': 'new awards and recognitions',
  'company-certifications-accreditations': 'new certifications and accreditations',
  'company-client-success-stories': 'new client success stories',
  'company-csr-initiatives': 'new CSR initiatives',
  'company-employee-wellbeing-culture': 'new employee well-being and culture initiatives',
  'company-event-participation-announcements': 'new event participation and announcements',
  'company-financial-updates': 'new financial updates',
  'company-health-safety-incidents': 'new health and safety incident',
  'company-leadership-changes': 'new leadership changes',
  'company-leavers': 'new leavers',
  'company-litigation-regulatory-issues': 'new litigation regulatory issues',
  'company-market-trends-insights': 'new market trends and insights',
  'company-mobile-found': 'new company mobiles found',
  'company-new-job-posted': 'new jobs posted',
  'company-new-joiner': 'new joiners',
  'company-new-product-service-launch': 'new product and service launches',
  'company-operational-updates': 'new operational updates',
  'company-partnership-announcement': 'new partnership announcements',
  'company-product-business-expansion': 'new product and business expansions',
  'company-product-promotions': 'new product promotions',
  'company-project-updates': 'new project updates',
  'company-public-relations': 'new public relations announcements',
  'company-recruitment-hiring': 'new recruitment and hiring updates',
  'company-regulatory-compliance': 'new compliance updates',
  'company-security-information': 'new security information updates',
  'company-service-disruptions': 'new service disruptions',
  'company-strategy-updates': 'new strategy updates',
  'company-thought-leadership-content': 'new thought leadership content',

  // New appointments and funding
  'new-c-suite-appointment': 'new C-suite appointments',
  'new-funding-announcement': 'new funding announcement',
  'new-worksafe-prosecution-recorded': 'new worksafe prosecution recorded',

  // Person signals
  'person-left-from-company': 'people left a role',
  'person-mobile-found': 'person mobiles found',
  'person-new-role': 'people new in role',
  'person-role-change': 'people with role changes',
  'person-work-email-found': 'work emails found',

  // SI-C signals
  'si-c-bankr': 'new bankruptcy and insolvency updates',
  'si-c-closs': 'new client and partnership loss updates',
  'si-c-compi': 'new competitive intelligence updates',
  'si-c-fundc': 'new funding announcement',
  'si-c-invst': 'new investment updates',
  'si-c-manda': 'new mergers and acquisitions',
  'si-c-reorg': 'new reorganisation and restructuring',
};
